export default function (Quill, modulePath, module) {
  if (!Quill.imports[modulePath]) {
    Quill.register(modulePath, module, true);
  }
}
